import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import Swal from "sweetalert2";
import { BaseInput, BaseSelect, BaseButton } from "../../components/ui";
import contratoService from "../../services/contratoService";
import pagoService from "../../services/pagoService";

const METODOS_PAGO = [
  { value: 'efectivo', label: 'Efectivo' },
  { value: 'transferencia', label: 'Transferencia' },
  { value: 'tarjeta', label: 'Tarjeta' },
  { value: 'yape', label: 'Yape' },
  { value: 'plin', label: 'Plin' },
  { value: 'paypal', label: 'PayPal' },
];

const TIPOS_PAGO = [
  { value: 'alquiler', label: 'Alquiler' },
  { value: 'servicio_adicional', label: 'Servicio adicional' },
];

const PagosRegistrar = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [contratos, setContratos] = useState([]);
  const [formData, setFormData] = useState({
    contrato_id: '',
    monto: '',
    metodo_pago: '',
    tipo_pago: '',
    fecha_pago: '',
    observacion: '',
  });

  useEffect(() => {
    const fetchContratos = async () => {
      try {
        const data = await contratoService.obtenerContratosDetalles();
        setContratos(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error al obtener contratos:", error);
      }
    };

    fetchContratos();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      await pagoService.crearPago({
        contrato_id: Number(formData.contrato_id),
        monto: parseFloat(formData.monto),
        metodo_pago: formData.metodo_pago,
        tipo_pago: formData.tipo_pago,
        fecha_pago: formData.fecha_pago,
        fecha_real_pago: formData.fecha_pago,
        observacion: formData.observacion || undefined,
        estado: 'pagado',
      });

      Swal.fire({
        title: "¡Éxito!",
        text: "Pago registrado correctamente",
        icon: "success",
      }).then(() => navigate("/contabilidad-pagos"));
    } catch (error) {
      console.error("Error al registrar pago:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "No se pudo registrar el pago",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const contratoOptions = contratos.map((contrato) => ({
    value: contrato.id,
    label: contrato.inquilino_nombre
      ? `Contrato ${contrato.id} - ${contrato.inquilino_nombre}`
      : `Contrato ${contrato.id}`,
  }));

  return (
    <>
      <Header />
      <Sidebar id="menu-item6" id1="menu-items6" activeClassName="pagos-registrar" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/contabilidad-pagos">Contabilidad</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <FiChevronRight />
                  </li>
                  <li className="breadcrumb-item active">Registrar pago</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Registrar pago</h4>
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseSelect
                          label="Contrato"
                          name="contrato_id"
                          required
                          isSearchable
                          value={formData.contrato_id}
                          onChange={handleChange}
                          placeholder="Seleccionar contrato"
                          options={contratoOptions}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseInput
                          label="Monto"
                          name="monto"
                          type="number"
                          required
                          restrict="decimal"
                          min="0"
                          step="0.01"
                          value={formData.monto}
                          onChange={handleChange}
                          placeholder="0.00"
                          startIcon={<span>S/</span>}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseSelect
                          label="Método de pago"
                          name="metodo_pago"
                          required
                          value={formData.metodo_pago}
                          onChange={handleChange}
                          placeholder="Seleccionar método"
                          options={METODOS_PAGO}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseSelect
                          label="Tipo de pago"
                          name="tipo_pago"
                          required
                          value={formData.tipo_pago}
                          onChange={handleChange}
                          placeholder="Seleccionar tipo"
                          options={TIPOS_PAGO}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseInput
                          label="Fecha de pago"
                          name="fecha_pago"
                          type="date"
                          required
                          value={formData.fecha_pago}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseInput
                          label="Observación"
                          name="observacion"
                          value={formData.observacion}
                          onChange={handleChange}
                          placeholder="Opcional"
                        />
                      </div>

                      <div className="col-12 d-flex justify-content-end gap-2 mt-2">
                        <BaseButton
                          type="button"
                          variant="secondary"
                          onClick={() => navigate("/contabilidad-pagos")}
                        >
                          Cancelar
                        </BaseButton>
                        <BaseButton type="submit" variant="primary" loading={loading} disabled={loading}>
                          Registrar pago
                        </BaseButton>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PagosRegistrar;
